import Parse from 'parse'
import store from "../store";

function getAllUser() {
    return new Parse.Query(Parse.User).find({useMasterKey: true}).then(users => {
        store.commit('user/SET_USERS', users)
    });
}

function getAllRole() {
    return new Parse.Query(Parse.Role).find({useMasterKey: true}).then(roles => {
        store.commit('user/SET_ROLES', roles)
    });
}

function findUser() {

}

/*todo://add user to role permissions*/
function addUser({username, email, password, role}) {
    let user = new Parse.User();
    user.setUsername(username);
    user.setPassword(password);
    user.setEmail(email);
    return user.signUp(null, {useMasterKey: true}).then(u => {
        role.role.getUsers().add(u);
        return role.role.save(null, {useMasterKey: true}).then(() => {
            return u;
        });
    });
}

function editUser({user,username, email, password}) {
    user.setUsername(username);
    user.setEmail(email);
    user.setPassword(password);
    return user.save(null,{useMasterKey:true})
}

export const ParseUserService = {
    getAllUser,
    getAllRole,
    findUser,
    addUser,
    editUser,
};